import { ExternalSettings } from "../external-settings/external-settings.interface";
import { InternalSettings } from "../internal-settings/internal-settings.interface";
import { hasAllPermissions, hasOnePermission } from "../internal-settings/internal-settings.service";
import { PAActivity, PAGroup, PASection } from "./pa-menu-meta";

export class PABaseUtility {

  protected static es: ExternalSettings;
  protected static is: InternalSettings;

  public static init(es: ExternalSettings, is: InternalSettings) {
    this.es = es;
    this.is = is;
  }

  public static filterActivities(activities: PAActivity[]): PAActivity[] {
    let filtered = activities.filter((activity: PAActivity) => {
      if (activity.isModuleEnabled == undefined || activity.isModuleEnabled) {
        if (activity.checkFunction) {
          return activity.checkFunction(this.is, this.es);
        }
        if (activity.checkOnePermission != undefined && activity.checkOnePermission) {
          return hasOnePermission(activity.permissions, this.is.permissions);
        } else {
          return hasAllPermissions(activity.permissions, this.is.permissions);
        }
      }
      return false;
    });
    filtered.forEach((ele: PAActivity, index: number) => {
      ele.index = index + 1;
    })
    return filtered;
  }

  public static filterGroups(groups: PAGroup[]): PAGroup[] {
    let filtered = groups.filter((group: PAGroup) => {
      if (group.activities.length > 0) {
        if (group.isModuleEnabled == undefined || group.isModuleEnabled) {
          return true;
        }
      }
      return false;
    });
    filtered.forEach((ele: PAGroup, index: number) => {
      ele.index = index + 1;
    })
    return filtered;
  }

  public static filterSections(sections: Map<string, PASection>): Map<string, PASection> {
    const newSections: Map<string, PASection> = new Map();
    let index = 0;
    sections.forEach((v: PASection, key: string) => {
      if (v.groups.length > 0) {
        v.index = index++;
        newSections.set(key, v);
      }
    })
    return newSections;
  }

  public static filterMobileGroups(groups: PAGroup[]): PAGroup[] {
    let permittedGroup: PAGroup[] = [];
    groups.forEach((group: PAGroup) => {
      if ((group.activities == undefined || group.activities.length == 0)
        && (group.permissions == undefined || group.permissions.length == 0)
        && group.isModuleEnabled == undefined) {
        return;
      }

      if (group.activities.length > 0) {
        if (group.isModuleEnabled == undefined || group.isModuleEnabled) {
          permittedGroup.push(group);
        }
      } else {
        if (group.isModuleEnabled === false) return;

        if (group.isModuleEnabled) {
          permittedGroup.push(group);
          return;
        }

        if (group.permissions) {
          if (group.checkOnePermission != undefined && group.checkOnePermission) {
            if (!hasOnePermission(group.permissions, this.is.permissions)) {
              return;
            } else {
              permittedGroup.push(group);
            }
          } else {
            if (!hasAllPermissions(group.permissions, this.is.permissions)) {
              return;
            } else {
              permittedGroup.push(group);
            }
          }
        }
      }
    })
    permittedGroup.forEach((ele: PAGroup, index: number) => {
      ele.index = index + 1;
    })
    return permittedGroup;
  }
}